<script>
import { BuyProductService } from '@/services'
import { useBuyProduct } from '@/use/buy'

import axios from 'axios'
import { AuthService } from '@/services'

export default {
  data() {
    return {
      items: [],
      isLoaded: false,

      branchID: 0,
      ornamentBuy: 0,
      ornamentSell: 1,
      ingotBuy: 2,
      ingotSell: 3,
      goldloaded: false,
      rec_type: '',
      date: new Date(),
    }
  },

  async created() {
    await this.meFetch()
    this.fetch()
  },

  methods: {
    async meFetch() {
      try {
        const {
          data: { result }
        } = await AuthService.getMe()
        const branch = result.branch
        this.branchID = branch.id

      } catch (e) {
        console.log(e)
      } finally {
        const today = new Date()
        const newDate = new Date(today.getTime() - (today.getTimezoneOffset() * 60000));

        this.goldFetch(this.branchID, newDate)
      }
    },

    async goldFetch(branchID, golddate) {
      //--- Call gold price api from monitor server ---
      const api = axios.create({
        baseURL: process.env.VUE_APP_API_ENDPOINT_M
      })

      const params = `?branch=${branchID}&date=${golddate.toISOString().split('.')[0]}`
      api.get('api/v1/gold_latest/' + params).then(response => {
        //--- get only ingot gold ---
        const gold_recent = response.data.recent_golds
        this.ornamentBuy = parseFloat(gold_recent.ornament_buy)
        this.ornamentSell = parseFloat(gold_recent.ornament_sold)
        this.ingotBuy = parseFloat(gold_recent.ingot_buy)
        this.ingotSell = parseFloat(gold_recent.ingot_sold)
        this.rec_type = gold_recent.type
        this.date = new Date(gold_recent.fromdate)
        this.goldloaded = true

        //console.log(gold_recent)
      }).catch(err => {
        console.log(err.response)
      })
    },

    async fetch() {
      const getType = id => ({ 1: 'ingot', 2: 'ornament' }[id])

      try {
        const {
          data: { result }
        } = await BuyProductService.getAll({
          all: true
        })

        this.items = result.map(item => {
          return useBuyProduct({
            id: item.id,
            name: item.name,
            type: getType(item.ref_price.id),
            percent: +item.purity_percentage / 100,
            //price: +item.gold_price.buy_price
            price: this.ingotBuy
          })
        })
      } finally {
        this.isLoaded = true
      }
    }
  },

  render() {
    return (
      this.isLoaded &&
      this.$scopedSlots.default({
        items: this.items
      })
    )
  }
}
</script>
